import React,{useState} from 'react'
import Subheading from '../../components/Text/Subheading'
import Icon from '../../components/Text/Icon'
import arrowNodeIcon from '../../assets/nodeIcons/ArrowNode.svg'
import roundedNodeIcon from '../../assets/nodeIcons/RoundedNode.svg'
import triangleNodeIcon from '../../assets/nodeIcons/TriangleNode.svg'
import hexNodeIcon from '../../assets/nodeIcons/HexNode.svg'
import dNodeIcon from '../../assets/nodeIcons/DNode.svg'
import tapeNodeIcon from '../../assets/nodeIcons/TapeNode.svg'
import diamondNodeIcon from '../../assets/nodeIcons/DiamondNode.svg'
import cloudNodeIcon from '../../assets/nodeIcons/CloudNode.svg'
import crossNodeIcon from '../../assets/nodeIcons/CrossNode.svg'
import diamondRectNodeIcon from '../../assets/nodeIcons/DiamondRectNode.svg'
import skewRectNodeIcon from '../../assets/nodeIcons/SkewRectNode.svg'
import pentNodeIcon from '../../assets/nodeIcons/PentNode.svg'
import squircleNodeIcon from '../../assets/nodeIcons/SquircleNode.svg'
import cylinderNodeIcon from '../../assets/nodeIcons/CylinderNode.svg'
import arrowRectNodeIcon from '../../assets/nodeIcons/ArrowRectNode.svg'
import trapNodeIcon from '../../assets/nodeIcons/TrapNode.svg'
import refTrapNodeIcon from '../../assets/nodeIcons/RefTrapNode.svg'
import horCylinderNodeIcon from '../../assets/nodeIcons/HorCylinderNode.svg'
import rectNodeIcon from '../../assets/nodeIcons/RectNode.svg'
import textNodeIcon from '../../assets/nodeIcons/TextNode.svg'
import circleNodeIcon from '../../assets/nodeIcons/CircleNode.svg'
import youtubeLogo from '../../assets/integrations/youtube-logo.png'
import boxLogo from '../../assets/integrations/box-logo.png'
import docsLogo from '../../assets/integrations/docs-logo.png'
import sheetsLogo from '../../assets/integrations/sheets-logo.webp'
import slidesLogo from '../../assets/integrations/slides-logo.png'
import figmaLogo from '../../assets/integrations/figma-logo.png'
import loomLogo from '../../assets/integrations/loom-logo.png'
import driveLogo from '../../assets/integrations/drive-logo.webp'

const basicNodes=[
    {type: 'noteNode',icon: null,bsIcon: 'sticky-fill',title: 'Note Node',isNote: true},
    {type: 'textNode',icon: textNodeIcon,title: 'Text Node'},
    {type: 'rectNode',icon: rectNodeIcon,title: 'Rectangle'},
    {type: 'squircleNode',icon: squircleNodeIcon,title: 'Squircle'},
    {type: 'roundedNode',icon: roundedNodeIcon,title: 'Rounded Rectangle'},
    {type: 'diamondNode',icon: diamondNodeIcon,title: 'Diamond'},
    {type: 'circleNode',icon: circleNodeIcon,title: 'Circle'},
]

const flowchartNodes=[
    {type: 'arrowRectNode',icon: arrowRectNodeIcon,title: 'Arrow Rectangle'},
    {type: 'diamondRectNode',icon: diamondRectNodeIcon,title: 'Diamond Rectangle'},
    {type: 'skewRectNode',icon: skewRectNodeIcon,title: 'Parallelogram'},
    {type: 'cylinderNode',icon: cylinderNodeIcon,title: 'Cylinder'},
    {type: 'horCylinderNode',icon: horCylinderNodeIcon,title: 'Horizontal Cylinder'},
    {type: 'refTrapNode',icon: refTrapNodeIcon,title: 'Inverted Trapezoid'},
    {type: 'trapNode',icon: trapNodeIcon,title: 'Trapezoid'},
    {type: 'hexNode',icon: hexNodeIcon,title: 'Hexagon'},
    {type: 'pentNode',icon: pentNodeIcon,title: 'Pentagon'},
    {type: 'triangleNode',icon: triangleNodeIcon,title: 'Triangle'},
    {type: 'cloudNode',icon: cloudNodeIcon,title: 'Cloud'},
    {type: 'crossNode',icon: crossNodeIcon,title: 'Cross'},
    {type: 'arrowNode',icon: arrowNodeIcon,title: 'Arrow'},
    {type: 'dNode',icon: dNodeIcon,title: 'D Shape'},
    {type: 'tapeNode',icon: tapeNodeIcon,title: 'Tape'},
]

const integrationNodes=[
    {type: 'youtubeNode',icon: youtubeLogo,title: 'YouTube'},
    {type: 'loomNode',icon: loomLogo,title: 'Loom'},
    {type: 'figmaNode',icon: figmaLogo,title: 'Figma'},
    {type: 'googleDocsNode',icon: docsLogo,title: 'Google Docs'},
    {type: 'googleSheetsNode',icon: sheetsLogo,title: 'Google Sheets'},
    {type: 'googleSlidesNode',icon: slidesLogo,title: 'Google Slides'},
    {type: 'boxNode',icon: boxLogo,title: 'Box'},
    {type: 'googleDriveNode',icon: driveLogo,title: 'Google Drive'},
]

function NodeTile({node,onDragStart,addNode}) {
    if(node.isNote) {
        return (
            <div
                draggable='true'
                role="button"
                tabIndex={0}
                aria-label={`Add ${node.title} — drag to canvas or click to add`}
                className='flex justify-center items-center p-1 bg-yellow-50 rounded-md border border-yellow-300 shadow-sm transition-all cursor-pointer select-none aspect-square hover:bg-yellow-100 hover:border-yellow-400'
                onDragStart={(e)=>onDragStart(e,node.type)}
                onClick={()=>addNode(node.type)}
                onKeyDown={(e)=>(e.key==='Enter'||e.key===' ')&&addNode(node.type)}
                title={node.title}
            >
                <Icon icon={node.bsIcon} className='text-xl text-yellow-600' aria-hidden="true" />
            </div>
        )
    }
    return (
        <div
            draggable='true'
            role="button"
            tabIndex={0}
            aria-label={`Add ${node.title} — drag to canvas or click to add`}
            className='flex justify-center items-center p-1 bg-white rounded-md border border-gray-200 shadow-sm transition-all cursor-pointer select-none aspect-square hover:bg-gray-50 hover:border-primary-300'
            onDragStart={(e)=>onDragStart(e,node.type)}
            onClick={()=>addNode(node.type)}
            onKeyDown={(e)=>(e.key==='Enter'||e.key===' ')&&addNode(node.type)}
            title={node.title}
        >
            <img src={node.icon} alt='' aria-hidden="true" className='object-contain p-1.5 w-full h-full' />
        </div>
    )
}

function CollapsibleSection({title,children,defaultOpen=true}) {
    const [open,setOpen]=useState(defaultOpen)
    return (
        <div className='flex flex-col gap-1'>
            <button onClick={()=>setOpen(o=>!o)} className='flex items-center gap-1 w-full text-left group'>
                <Icon icon={open? 'chevron-down':'chevron-right'} className='!p-0 text-sm text-zinc-400 group-hover:text-dark transition-colors' />
                <Subheading className='text-sm'>{title}</Subheading>
            </button>
            {open&&<div className='grid grid-cols-4 gap-1.5 w-full'>{children}</div>}
        </div>
    )
}

export default function NodePalette({onClose,onDragStart,addNode}) {
    return (
        <div role="complementary" aria-label="Node palette" className='flex overflow-y-auto flex-col gap-3 p-2 w-full h-full border-r shadow-md lg:w-1/5 border-dark-100'>
            <div className='flex flex-row gap-2 justify-between items-center w-full'>
                <Subheading>Nodes</Subheading>
                <Icon onClick={onClose} icon='x' className='text-2xl cursor-pointer' />
            </div>

            <CollapsibleSection title='Basic' defaultOpen={true}>
                {basicNodes.map(node=>(
                    <NodeTile key={node.type} node={node} onDragStart={onDragStart} addNode={addNode} />
                ))}
            </CollapsibleSection>

            <CollapsibleSection title='Flowchart' defaultOpen={true}>
                {flowchartNodes.map(node=>(
                    <NodeTile key={node.type} node={node} onDragStart={onDragStart} addNode={addNode} />
                ))}
            </CollapsibleSection>

            <CollapsibleSection title='Integrations' defaultOpen={false}>
                {integrationNodes.map(node=>(
                    <NodeTile key={node.type} node={node} onDragStart={onDragStart} addNode={addNode} />
                ))}
            </CollapsibleSection>
        </div>
    )
}
